import zod from 'zod';

export const CameraPlayerSchema = zod.object({
    id: zod.string(),
});

export const CameraMapPlayerSchema = zod.object({
    id: zod.string(),
});

export const ManagementDetailsSchema = zod.object({
    id: zod.string().optional(),
});
